import React, { useContext, useState, useEffect } from "react";
import Base64Downloader from 'common-base64-downloader-react';
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.css";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import pharmacyAvatar from "../../pharmacies/icons/pharmacyAvatar.jpg";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import acceptedIcon from "./icons/checkMark.png";
import shippingIcon from "./icons/deliveryTruck.png";
import deliveredIcon from "./icons/delivered.png";
import { api } from "services/ApiService";
import {ApiEndpoint,Method} from "config/constants/apiConstants";
import { CircularProgress } from "@mui/material";
import FilePresentOutlinedIcon from "@mui/icons-material/FilePresentOutlined";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

const OrderDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [ordersData, setOrdersData] = useState([]);
  const [pharmacy, setPharmacy] = useState({});
  const [loading, setLoading] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  const [isShipping, setIsShipping] = useState(false);
  const [isDelivered, setDelivered] = useState(false);
  
  const path = location.pathname.split("/")[3];

  // const handleSelectChange = (event) => {
  //   setFilterOrders(event.target.value);
  // };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      // const result = await axios.get(url + "orders/" + path);
      const result = await api(ApiEndpoint.GET_ORDER_BY_ID + path,Method.GET,null,null);

      setOrdersData(result?.data);
      const res = await api(ApiEndpoint.GET_PHARMACY_BY_ID + result?.data?.pharmacyId,Method.GET,null,null);

      setPharmacy(res?.data);
      // const res = await axios.get(url + "users/" + result.data[0].user_id);
      // setUserData(res?.data);
      setLoading(false);
    };
    fetchData();
  }, [path]);

  useEffect(() => {
    switch (ordersData?.status) {
      case 'ACCEPTED':
        setIsAccepted(true);
        break;
      case 'SHIPPING':
        setIsAccepted(true);
        setIsShipping(true);
        break;
      case 'DELIVERED':
        setIsAccepted(true);
        setIsShipping(true);
        setDelivered(true);
        break;

      default:
        break;
    }
  }, [ordersData])
  

  if (loading) {
    return (
      <center style={{ marginTop: 200 }}>
        <CircularProgress />
      </center>
    );
  }

  return (
    <div className="orderDetailsMain">
      <>
        <Grid container>
          <Grid item xs={6} md={6} lg={8}>
            <div className="orderDetailsMainHeading">
              <div onClick={() => navigate(-1)}>
                <ArrowCircleLeftOutlinedIcon
                  className="headingIcon"
                  fontSize="large"
                />
              </div>
              <h3>Order Details</h3>
            </div>
          </Grid>
          {/* <Grid item xs={6} md={6} lg={4}>
            <Box sx={{ minWidth: 120 }} className="filterOrders">
              <FormControl fullWidth>
                <InputLabel id="filter-appointments-label">Orders</InputLabel>
                <Select
                  labelId="filter-appointments-label"
                  id="demo-simple-select"
                  value={filterOrders}
                  label="Orders"
                  onChange={handleSelectChange}
                >
                  <MenuItem value={"All"}>All</MenuItem>
                  <MenuItem value={"Accepted"}>Accepted</MenuItem>
                  <MenuItem value={"Pending"}>Pending</MenuItem>
                  <MenuItem value={"Completed"}>Completed</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Grid> */}
        </Grid>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            "& > :not(style)": {
              ml: 1,
              mr: 2,
              pl: 2,
              pb: 3,
              pt: 2,
              pr: 2,
              width: "100%",
              height: "auto",
            },
          }}
        >
          <Paper elevation={1} className="orderDetailsPaper">
            <div className="orderDetailsAvatar">
              <Stack direction="row" spacing={1}>
                <Avatar
                  alt="Patient Avatar"
                  src={pharmacy?.User?.profileImagePath || pharmacyAvatar}
                  variant="rounded"
                />
                <div className="orderDetailsName">
                  <h5>{pharmacy?.businessName}</h5>
                  <p>Order Status {ordersData?.status}</p>
                </div>
              </Stack>
              <div className="orderDetailsAppointment">
                <div className="orderDetailsType">
                  {/* <p>Appointment Name</p>
                  <h5>Eye Pressure Consultation</h5> */}
                </div>
                <div className="orderDetailsType">
                  <p>Total Prescriptions</p>
                  <h5>{ordersData?.prescriptions?.length} Prescription</h5>
                </div>
              </div>
            </div>

            <Grid container mt={5}>
              <Grid item lg={4} md={5} xs={12}>
                {(ordersData?.prescriptionList || []).map((item, key) => (
                  <div key={key} className="file-name">
                    <FilePresentOutlinedIcon  />
                    <p>{item?.name}.pdf</p>

                    <Base64Downloader
                      base64={`data:application/pdf;base64,${item?.prescriptionBase64PdfString}`}
                      downloadName={item?.name}
                      className="delete-file"
                    >
                      <FileDownloadOutlinedIcon />
                    </Base64Downloader>
                  </div>
                ))}
              </Grid>
              <Grid item lg={3} md={5} xs={12}>
                <h5>Order Status</h5>
                <div className="orderStatus">
                  {isAccepted ? (
                    <div className="orderStatusBtnChecked">
                      <Button variant="contained">
                        <img alt="accepted" src={acceptedIcon} width={40} />
                      </Button>
                      <h5>Accepted</h5>
                    </div>
                  ) : (
                    <div className="orderStatusBtn">
                      <Button variant="contained" disabled>
                        <img alt="accepted" src={acceptedIcon} width={40} />
                      </Button>
                      <h5>Accepted</h5>
                    </div>
                  )}
                  {isShipping ? (
                    <div className="orderStatusBtnChecked">
                      <Button variant="contained">
                        <img alt="accepted" src={shippingIcon} width={40} />
                      </Button>
                      <h5>Shipping</h5>
                      <p>{new Date(ordersData?.createdAt)?.toLocaleDateString()}</p>
                      <p>{new Date(ordersData?.createdAt)?.toLocaleTimeString()}</p>
                    </div>
                  ) : (
                    <div className="orderStatusBtn">
                      <Button variant="contained" disabled>
                        <img alt="accepted" src={shippingIcon} width={40} />
                      </Button>
                      <h5>Shipping</h5>
                    </div>
                  )}
                  {isDelivered ? (
                    <div className="orderStatusBtnChecked">
                      <Button variant="contained">
                        <img alt="accepted" src={deliveredIcon} width={40} />
                      </Button>
                      <h5>Delivered</h5>
                    </div>
                  ) : (
                    <div className="orderStatusBtn">
                      <Button variant="contained" disabled>
                        <img alt="accepted" src={deliveredIcon} width={40} />
                      </Button>
                      <h5>Delivered</h5>
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </>
    </div>
  );
};
export default OrderDetails;
